<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="domainVisible"
      width="50%"
      >
      <el-form :inline="true" :model="searchdata" class="form-inline" size="mini" @submit.native.prevent>
              <el-form-item >
                <el-input v-model="searchdata.data.field11" placeholder="查询社会信用代码" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
        <el-form-item >
          <el-input v-model="searchdata.data.name" placeholder="查询上级名称" @keyup.enter.native="searchTableData"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
          <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="350"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="企业域名称"
          prop="name"
          >
        </el-table-column>
        <el-table-column
                  label="统一社会信用代码"
                  prop="field11"
                  >
                </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="domainVisible = false" size="mini">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="handleClick" size="mini">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: [
    "visible",
    "dialogTitle",
    "parentList",
  ],
  data(){
    return{
      tableData: [],
      selectList: [],
      showSelectList: '',
      searchdata:{
        currpage: 1,
        pagelines: 999,
        isFromSettingParent: true,
        data:{
          name:"",
          username:'',
          field11: ''
        }
      },
    }
  },
  created(){
    this.tableData = [];
  },
  computed: {
    domainVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
  },
  methods:{
    /**
     * 获取企业域列表
     */
    getDomainList(){
      this.$api.getDomains(this.searchdata, {
        onSucess: response => {
          if(response.data.errcode == 0){
            let data = response.data.data;
            for(let i=0;i<data.datas.length;i++){
              if(data.datas[i].id == this.$route.query.domainid){
                data.datas.splice(i,1)
              }else{
                let parentList = this.parentList.split(";");
                for(let y=0;y<parentList.length;y++){
                  if(data.datas[i].id == parentList[y]){
                    this.showSelectList = this.showSelectList ? data.datas[i].id + ";" + this.showSelectList : data.datas[i].id
                  }
                }
              }
            }
            this.tableData = data.datas;
          }
        }
      });
    },
    handleSelectionChange(val){
      this.selectList = val;
    },
    /**
     * 确定按钮
     */
    handleClick(){
      let list = this.selectList;
      if(list.length >0){
        let domainListId = "";
        list.map((item)=>{
          if(domainListId){
            domainListId = domainListId + ";" + item.id;
          }else{
            domainListId = item.id;
          }
        })
        if(this.parentList){
          domainListId = domainListId + ";" +this.parentList;
        }
        const newArr = this.unique(domainListId.split(";"));
        let str = '';
        for(let i=0;i<newArr.length;i++){
          str = str ? str + ';' + newArr[i] : newArr[i];
        }
        this.domainVisible = false;
        this.tableData = [];
        this.searchdata.data.name = '';
        this.searchdata.data.field11 = '';
        this.$emit("selectChecked",str,"parent");
      }else{
        this.$message({
          message: '请选择数据',
          type: 'warning'
        });
      }
    },
    /**
     * 去重
     */
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr) && res.set(arr, 1));
    },
    /**
      查询
     */
    searchTableData(){
            if(this.searchdata.data.name == '' && this.searchdata.data.field11 == '')
              return false
            else
              this.getDomainList();
    },
    /**
      重置
     */
    resetSearchTableData(){
      this.searchdata.data.name='';
      this.searchdata.data.field11='';
            this.searchTableData();
    },
  },
  watch:{
    showSelectList(value){
      let that = this;
      let tableData = this.tableData;
      if(value.indexOf(";") > -1){
        let arr = value.split(";");
        this.$nextTick(()=>{
          that.$refs.multipleTable.clearSelection();
          for(let i=0;i<arr.length;i++){
            tableData.map((item)=>{
              if(arr[i] == item.id){
                that.$refs.multipleTable.toggleRowSelection(item,true);
              }
            })
          }
        })
      }else{
        this.$nextTick(()=>{
          that.$refs.multipleTable.clearSelection();
          tableData.map((item)=>{
            if(value == item.id){
              that.$refs.multipleTable.toggleRowSelection(item,true);
            }
          })
        })
      }
    },
  }
}
</script>